export default __webpack_public_path__ + "static/media/Firebase.fe7af5ca.png";